import login from './screens/login.json'
import profile from './screens/profile.json'
import indicators from './screens/indicators.json'
import searchVehicles from './screens/searchVehicles.json'
import unitDetail from './screens/unitDetail.json'
import policyDocumentsDialog from './screens/policyDocumentsDialog.json'
import notFoundUnitDialog from './screens/notFoundUnitDialog.json'
import appHeader from './screens/appHeader.json'
import appBottomNav from './screens/appBottomNav.json'
import functions from './models/functions.json'
import carClassifications from './models/carClassifications.json'
import unitStatus from './models/unitStatus.json'
import contractStatus from './models/contractStatus.json'
import ticketStatus from './models/ticketStatus.json'
import documentTypes from './models/documentTypes.json'
import insuranceType from './models/insuranceType.json'
import uploadDocument from './screens/uploadDocument.json'
import consultMaintenance from './screens/consultMaintenance.json'
import createMaintenance from './screens/createMaintenance.json'
import vehiclesCard from './screens/vehiclesCard.json'

const screens = {
    login,
    profile,
    indicators,
    searchVehicles,
    policyDocumentsDialog,
    notFoundUnitDialog,
    appHeader,
    appBottomNav,
    unitDetail,
    uploadDocument,
    createMaintenance,
    consultMaintenance,
    vehiclesCard
}

// Common labels and model-related translations shared between screens
const models = {
    functions,
    carClassifications,
    unitStatus,
    contractStatus,
    ticketStatus,
    documentTypes,
    insuranceType
}

export default {
    translation: {
        screens,
        models
    }
}
